import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AwardCommitteeMeeting } from '@tran-monorepo/interfaces';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AwardCommitteeService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${environment.apiConfig[1].uri}/v1/award-committee-meetings`;

    public getMeetingById(meetingId: string): Observable<AwardCommitteeMeeting> {
        return this.http.get<AwardCommitteeMeeting>(`${this.baseUrl}/${meetingId}`);
    }
}
